import React, { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { API_ENDPOINT } from "../../../../services/api/resources";
import { useSelector } from "react-redux";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const currentYear = new Date().getFullYear();

const VendorInvoiceDashboard = () => {
  const [invoiceData, setInvoiceData] = useState([]);
  const Data = useSelector((state) => state.loginData.value);
  // const org_token = Data?.organization_token;
  const user_token = Data?.user?.token || Data?.user_token;

  useEffect(() => {
    axios
      .post(API_ENDPOINT.monthly_invoice_summary, { org_token: user_token })
      .then((res) => {
        setInvoiceData(res.data.data || []);
      });
  }, []);

  console.log("api", invoiceData);

  const chartData = {
    labels: months.map((m) => `${m} (${currentYear})`), // e.g. Jan (2025)

    datasets: invoiceData.map((vendor, i) => ({
      label: vendor["merchant_name"],
      data: months.map((month) => {
        const key = `${month.toLowerCase()}_${currentYear}`; // e.g. jan_2025
        return vendor[key] || 0;
      }),
      borderColor: `hsl(${(i * 60) % 360}, 70%, 50%)`,
      backgroundColor: `hsl(${(i * 60) % 360}, 70%, 80%)`,
      tension: 0.3,
      fill: false,
    })),
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: `Monthly Invoice Summary (${currentYear})`,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        grid: { display: false },
      },
    },
  };

  return (
    <div style={{ maxWidth: "1000px", margin: "auto", padding: "1rem" }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default VendorInvoiceDashboard;
